export const d_M_yyyy_fullStop = 'd.M.yyyy';
export const dd_MM_yyyy_fullStop = 'dd.MM.yyyy';
export const dd_MM_yy_fullStop = 'dd.MM.yy';
export const dd_MM_fullStop = 'dd.MM.';
export const ddMM = 'ddMM';
export const MMdd = 'MMdd';
export const ddMMyy = 'ddMMyy';
export const yyMMdd = 'yyMMdd';
export const ddMMyyyy = 'ddMMyyyy';
export const ddMMyyyyHHmm = 'ddMMyyyyHHmm';
export const _dd_MM_yyyy_HH_mm_fullStop = '_dd.MM.yyyy_HH.mm';
export const yyyy_MM_dd_fullStop = 'yyyy.MM.dd';
export const yyyy_MM_dd_hyphen = 'yyyy-MM-dd';
export const yyyy_MM_hyphen = 'yyyy-MM';
export const yyyyMMdd = 'yyyyMMdd';
export const dd_MM_yyyy_HH_mm_ss_fullStop = 'dd.MM.yyyy HH:mm:ss';
export const yyyy_MM_dd_H_mm_fullStop = 'dd.MM.yyyy H:mm';
export const yyyy_MM_ddTHH_mm_ss_hyphen = "yyyy-MM-dd'T'HH:mm:ss";
export const yyyy_MM_ddTHH_mm_ss_timezone_hyphen = "yyyy-MM-dd'T'HH:mm:ssXXX";
export const yyyyMMddTHHmmss_SSSSxxxx_fullstop = 'yyyyMMddHHmmss.SSSSxxxx';
export const dd_MM_yyyy_HH_mm_fullStop = 'dd.MM.yyyy HH:mm';
export const dd_MM_yyyy_comma_HH_mm_fullStop = 'dd.MM.yyyy, HH:mm';
export const yyyy_MM_dd_HH_mm_ss_SSS_hyphen = 'yyyy-MM-dd HH:mm:ss.SSS';
export const HH_mm_ss_SSS_hyphen = 'HH:mm:ss.SSS';
export const yyyy_MM_dd_HH_mm_hyphen = 'yyyy-MM-dd HH:mm';
export const q_yyyy_hyphen = 'Q  - yyyy';
export const qyyyy = 'Qyyyy';
export const q_yyyy_space = 'Q yyyy';
export const yyyyq = 'yyyyQ';
export const yyyyMMddHHmm = 'yyyyMMddHHmm';
export const yyyyMMddHHmmX = 'yyyyMMddHHmmX'; // "X" represents the timezone offset
export const yyyyMMddHHmmss = 'yyyyMMddHHmmss';
export const yyddMMhhmmss = 'yyMMddhhmmss';
export const yyyyMMddTHHmmssZ = "yyyyMMdd'T'HHmmss'Z'";
export const MMM_yyyy = 'MMM yyyy';
export const MMMM_yyyy = 'MMMM yyyy';
export const yyyy = 'yyyy';
export const yy = 'yy';
export const L = 'L';
export const LL = 'LL';
export const H_mm = 'H:mm';
export const HH_mm = 'HH:mm';
export const HHmm = 'HHmm';
export const MMyy = 'MM/yy';
export const yyyy_MM_dd_HH_mm_ss_hyphen_per_block_concat_by_underscore = 'yyyy-MM-dd_HH-mm-ss';
export const weekday = 'EEEE';

export type DateFormats =
  | typeof d_M_yyyy_fullStop
  | typeof dd_MM_yyyy_fullStop
  | typeof dd_MM_yy_fullStop
  | typeof dd_MM_fullStop
  | typeof ddMM
  | typeof MMdd
  | typeof ddMMyy
  | typeof yyMMdd
  | typeof ddMMyyyy
  | typeof _dd_MM_yyyy_HH_mm_fullStop
  | typeof yyyy_MM_dd_fullStop
  | typeof yyyy_MM_dd_hyphen
  | typeof yyyyMMdd
  | typeof dd_MM_yyyy_HH_mm_ss_fullStop
  | typeof yyyy_MM_dd_H_mm_fullStop
  | typeof yyyy_MM_ddTHH_mm_ss_hyphen
  | typeof yyyy_MM_ddTHH_mm_ss_timezone_hyphen
  | typeof dd_MM_yyyy_HH_mm_fullStop
  | typeof dd_MM_yyyy_comma_HH_mm_fullStop
  | typeof yyyy_MM_dd_HH_mm_ss_SSS_hyphen
  | typeof HH_mm_ss_SSS_hyphen
  | typeof yyyy_MM_dd_HH_mm_hyphen
  | typeof q_yyyy_hyphen
  | typeof qyyyy
  | typeof yyyyq
  | typeof yyyyMMddHHmmss
  | typeof yyddMMhhmmss
  | typeof MMM_yyyy
  | typeof MMMM_yyyy
  | typeof yyyy
  | typeof yy
  | typeof L
  | typeof LL
  | typeof H_mm
  | typeof HH_mm
  | typeof HHmm
  | typeof MMyy
  | typeof yyyy_MM_dd_HH_mm_ss_hyphen_per_block_concat_by_underscore
  | typeof weekday;
